import { RadarChart } from "@components/Spider/RadarChart";
import styles from "./styles.module.scss";

export const SpiderChart = ({ AspectsStats, activeIndex, setActiveIndex }) => {
  const radarData = AspectsStats.map((aspect) => ({
    label: aspect.aspect,
    value: aspect.bayesian_avg.toFixed(1),
  }));

  const handleDotClick = (index: number) => {
    setActiveIndex(index);
  };

  return (
    <div className={styles.wrapper}>
      <RadarChart
        datasets={[
          {
            label: "Current Aspect",
            data: radarData.map((item) => item.value),
            borderColor: "#5295E0",
          },
        ]}
        padding={0}
        activeIndex={activeIndex}
        onDotClick={handleDotClick}
        isDragEnabled={true}
        showTooltipWithArrow={false}
        blockChanging={false}
        width={530}
        height={500}
        labelFontSize={11}
        suggestedMax={10}
        productOneTitles={radarData.map((item) => item.label)}
        productOneValues={radarData.map((item) => parseFloat(item.value))}
        productTwoValues={[]}
      />
    </div>
  );
};
